// helpers/giftCardAPI.js
import { authFetch } from "./authFetch";

export const fetchData = async (url, options = {}) => {
  const response = await authFetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || `HTTP error ${response.status}`);
  }

  return response.json();
};
